export const myCvTranslations = {
  lv: {
    title: 'Mans CV',
    personal: 'Mani dati',
    subtitle: 'Katrs ieraksts tiek saglabāts atsevišķi.',
    add: 'Pievienot',
    edit: 'Rediģēt',
    remove: 'Dzēst',
    save: 'Saglabāt',
    saved: 'Izmaiņas saglabātas',
    removed: 'Ieraksts dzēsts',
    saveFailed: 'Neizdevās saglabāt. Mēģiniet vēlreiz.',
    removeFailed: 'Neizdevās dzēst. Mēģiniet vēlreiz.',
    removeTitle: 'Dzēst ierakstu',
    confirmRemove: 'Vai tiešām dzēst šo ierakstu?',
    empty: 'Nav ierakstu',
    actions: 'Darbības',
    ongoing: 'šobrīd',
    required: 'Lauks ir obligāts',
    tillBeforeFrom: 'Beigu mēnesis nevar būt pirms sākuma mēneša',
    tillHint: 'Atstājiet tukšu, ja turpinās',
    education: {
      title: 'Izglītība',
      name: 'Mācību iestāde',
      specialty: 'Specialitāte',
      level: 'Līmenis',
      period: 'Periods',
      from: 'No',
      till: 'Līdz',
      description: 'Apraksts',
    },
    work: {
      title: 'Darba pieredze',
      name: 'Darba devējs',
      position: 'Amats',
      period: 'Periods',
      from: 'No',
      till: 'Līdz',
      description: 'Apraksts',
    },
    computerSkills: {
      title: 'Datorprasmes',
      name: 'Prasme',
      level: 'Līmenis',
      description: 'Apraksts',
    },
    driverLicenses: {
      title: 'Autovadītāja apliecība',
      category: 'Kategorija',
      ownCar: 'Sava automašīna',
    },
    languages: {
      title: 'Valodas',
      language: 'Valoda',
      code: 'Valodas kods',
      codeHint: 'Divu burtu kods, piem., en',
      codeInvalid: 'Ievadiet divu burtu valodas kodu',
      understanding: 'Saprašana',
      speaking: 'Runāšana',
      writing: 'Rakstīšana',
    },
    otherSkills: {
      title: 'Citas prasmes',
      empty: 'Nav norādītas',
    },
    educationLevels: {
      Secondary: 'Vidējā izglītība',
      ProfSecondary: 'Profesionālā vidējā izglītība',
      College: 'Koledža',
      Bachelor: 'Bakalaurs',
      Masters: 'Maģistrs',
      Doctor: 'Doktors',
      ProfRandom: 'Profesionālā izglītība',
      NotSet: 'Nav norādīts',
    },
    skillLevels: {
      Basic: 'Pamatlīmenis',
      Average: 'Vidējs',
      AboveAverage: 'Virs vidējā',
      Expert: 'Eksperts',
      NotSet: 'Nav norādīts',
    },
    languageLevels: {
      Beginner: 'Iesācējs',
      Intermediate: 'Vidējs',
      UpperIntermediate: 'Virs vidējā',
      Advanced: 'Augsts',
      Mastery: 'Izcils',
      Native: 'Dzimtā valoda',
      NotSet: 'Nav norādīts',
    },
    driverCategories: {
      AM: 'AM',
      A1: 'A1',
      A2: 'A2',
      A: 'A',
      B: 'B',
      BE: 'BE',
      C1: 'C1',
      C1E: 'C1E',
      C: 'C',
      CE: 'CE',
      D1: 'D1',
      D1E: 'D1E',
      D: 'D',
      DE: 'DE',
      Code95: '95. kods',
      Forklift: 'Iekrāvējs',
    },
  },
  en: {
    title: 'My CV',
    personal: 'My data',
    subtitle: 'Each entry is saved separately.',
    add: 'Add',
    edit: 'Edit',
    remove: 'Delete',
    save: 'Save',
    saved: 'Changes saved',
    removed: 'Entry deleted',
    saveFailed: 'Could not save. Please try again.',
    removeFailed: 'Could not delete. Please try again.',
    removeTitle: 'Delete entry',
    confirmRemove: 'Delete this entry?',
    empty: 'No entries',
    actions: 'Actions',
    ongoing: 'present',
    required: 'This field is required',
    tillBeforeFrom: 'The end month cannot be before the start month',
    tillHint: 'Leave empty if ongoing',
    education: {
      title: 'Education',
      name: 'Institution',
      specialty: 'Specialty',
      level: 'Level',
      period: 'Period',
      from: 'From',
      till: 'Till',
      description: 'Description',
    },
    work: {
      title: 'Work experience',
      name: 'Employer',
      position: 'Position',
      period: 'Period',
      from: 'From',
      till: 'Till',
      description: 'Description',
    },
    computerSkills: {
      title: 'Computer skills',
      name: 'Skill',
      level: 'Level',
      description: 'Description',
    },
    driverLicenses: {
      title: 'Driver license',
      category: 'Category',
      ownCar: 'Own car',
    },
    languages: {
      title: 'Languages',
      language: 'Language',
      code: 'Language code',
      codeHint: 'Two-letter code, e.g. en',
      codeInvalid: 'Enter a two-letter language code',
      understanding: 'Understanding',
      speaking: 'Speaking',
      writing: 'Writing',
    },
    otherSkills: {
      title: 'Other skills',
      empty: 'Not provided',
    },
    educationLevels: {
      Secondary: 'Secondary education',
      ProfSecondary: 'Vocational secondary education',
      College: 'College',
      Bachelor: 'Bachelor',
      Masters: 'Masters',
      Doctor: 'Doctorate',
      ProfRandom: 'Vocational education',
      NotSet: 'Not specified',
    },
    skillLevels: {
      Basic: 'Basic',
      Average: 'Average',
      AboveAverage: 'Above average',
      Expert: 'Expert',
      NotSet: 'Not specified',
    },
    languageLevels: {
      Beginner: 'Beginner',
      Intermediate: 'Intermediate',
      UpperIntermediate: 'Upper intermediate',
      Advanced: 'Advanced',
      Mastery: 'Mastery',
      Native: 'Native',
      NotSet: 'Not specified',
    },
    driverCategories: {
      AM: 'AM',
      A1: 'A1',
      A2: 'A2',
      A: 'A',
      B: 'B',
      BE: 'BE',
      C1: 'C1',
      C1E: 'C1E',
      C: 'C',
      CE: 'CE',
      D1: 'D1',
      D1E: 'D1E',
      D: 'D',
      DE: 'DE',
      Code95: 'Code 95',
      Forklift: 'Forklift',
    },
  },
}
